import React from 'react';
import PropTyes from 'prop-types';

const Loading = (props) => (
    <div className= 'd-flex flex-column flex-wrap justify-content-center w-100 pb-5'>
        <p className="loading-message">
            <i>
                {props.messaggio}
            </i>
        </p>
        <div className="spinner">
            <div className="dot1"/>
            <div className="dot2"/>
        </div>
    </div>
);

Loading.PropTyes = {
    messaggio: PropTyes.string.isRequired
};

export default Loading;

